import * as actions from "./actions";
import instance from "../axios";
import { getTeamData } from "./testDataTeams";

export const getTeams = () => {
  return (dispatch: any) => {
    return instance
      .get(`v1/team?timestamp=${new Date().getTime()}`)
      .then((res: any) => {
        // console.log("Setting teams");
        // console.log(res.data.length);
        //console.log(res.data);
        dispatch(actions.setAllTeams(res.data));
        return res.data;
      })
      .catch((err: any) => {
        console.log(err);
      });
  };
};

export const addTeam = (team: any) => {
  return (dispatch: any) => {
    dispatch(actions.addTeamSuccess({ team }));
  };
};

export const loadTestTeamData = (count: number) => {
  return (dispatch: any) => {
    let teamData = getTeamData(count);
    dispatch(actions.addTestTeamDataSuccess(teamData));
    return teamData;
  };
};

export const removeTeam = (team: any) => {
  return (dispatch: any) => {
    dispatch(actions.removeTeamSuccess(team));
  };
};

export const updateTeam = (team: any) => {
  return (dispatch: any) => {
    return instance
      .put(`v1/team/update/${team.teamId}`, team)
      .then((res: any) => {
        dispatch(
          actions.updateTeamSuccess({
            ...res.data.team,
            playerCount: team.playerCount,
          })
        );
        return true;
      })
      .catch((err: any) => {
        console.log(err);
      });
  };
};

export const updateStoreTeam = (team: any) => {
  return (dispatch: any) => {
    dispatch(actions.updateTeamSuccess(team));
  };
};

export const clearTeams = () => {
  console.log("clear teams");
  return (dispatch: any) => {
    dispatch(actions.clearTeamsSuccess());
  };
};

export const registerTeam = (team: any, quizConfig: any) => {
  return (dispatch: any) => {
    return instance
      .post(`v1/team/register`, team)
      .then((res: any) => {
        dispatch(
          actions.addTeamSuccess({
            team: {
              ...res.data.team,
              playerCount: team.playerCount,
              ...populateTeamData(quizConfig),
            },
            quizConfig,
          })
        );
        dispatch(
          actions.registerTeamSuccess({
            ...res.data.team,
            playerCount: team.playerCount,
          })
        );
        return res.data;
      })
      .catch((err: any) => {
        console.log(err);
      });
  };
};

export const submitTeamResults = (
  teamId: number,
  roundId: number,
  results: number
) => {
  return (dispatch: any) => {
    dispatch(actions.setResults({ teamId, roundId, results }));
    dispatch(actions.teamScoresUpdated());
  };
};

export const submitTeamCWResults = (teamId: number, results: number) => {
  return (dispatch: any) => {
    dispatch(actions.setCWResults({ teamId, results }));
    dispatch(actions.teamScoresUpdated());
  };
};

export const submitBreakerAnswer = (
  teamId: number,
  correctAnswer: number,
  answer: number
) => {
  return (dispatch: any) => {
    dispatch(actions.setBreakerAnswer({ teamId, correctAnswer, answer }));
    dispatch(actions.teamScoresUpdated());
  };
};

export const setBreakerResults = (teamId: number, answer: number) => {
  return (dispatch: any) => {
    dispatch(actions.setBreakerResultsSuccess({ teamId, answer }));
    dispatch(actions.teamScoresUpdated());
  };
};

export const submitScores = () => {
  return (dispatch: any) => {
    dispatch(actions.submitScoresSuccess());
    dispatch(actions.teamScoresUpdated());
  };
};

const populateTeamData = (quizConfig: any) => {
  const rounds = Array(quizConfig.format.rounds).fill(null);
  let teamConfig: any = {};
  if (Boolean(quizConfig.format.hasBreaker)) {
    teamConfig.breaker = { answer: null, proximity: null, rank: null };
  }
  if (Boolean(quizConfig.format.isCrossword)) {
    teamConfig.puzzle = new Array(quizConfig.puzzle.questionCount).fill(null);
  }
  console.log({ rounds, ...teamConfig });
  return { rounds, ...teamConfig };
};
